import { useDispatch } from "react-redux";

import { setSearchMetrics } from "@/components/CloneView/state/cloneContextReducer";
import { fetchMetrics } from "@/services/api/helpers";
import { mondayService } from "@/services/monday-service";
import { useQuery } from "@tanstack/react-query";

const useMetricsPreloading = () => {
  const dispatch = useDispatch();

  useQuery({
    queryKey: ["METRICS"],
    queryFn: async () => {
      dispatch(setSearchMetrics({ data: [], isLoading: true }));
      const sessionToken = await mondayService.getSessionToken();
      return fetchMetrics(sessionToken);
    },
    refetchOnWindowFocus: false,
    initialData: [],
    onSuccess: (data) => {
      if (!data.length) {
        dispatch(setSearchMetrics({ data: [], isLoading: false }));
        return;
      }

      dispatch(setSearchMetrics({ data, isLoading: false }));
    },
  });
};

export default useMetricsPreloading;
